export const authorImageStyleR = {
    width: '3.3333333333333335vw',
    height: '3.3333333333333335vw', 
    objectFit: 'cover', 
    borderRadius: '0.625vw',
    marginLeft: '0.8333333333333334vw',
};